import React, { Component } from 'react';
import { Link, Redirect, withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Typography } from '@mui/material';
import { CreatePasswordField } from '../../inputs/text-fields/passwords/CreatePasswordField';
import { PasswordField } from '../../inputs/text-fields/passwords/PasswordField';
import { TextField } from '../../inputs';
import CBButton from '../../Buttons/CbButton';
import { validatePassword } from '../../../api/SignupService';

class SignupEmailExisting extends Component {
  constructor(props: any) {
    super(props);
    const email = props.data ? props.data.email : '';
    const firstName = props.data ? props.data.firstName : '';
    const lastName = props.data ? props.data.lastName : '';
    const tokenType = props.data ? props.data.tokenType : '';

    this.state = {
      email,
      firstName,
      lastName,
      tokenType,
      deepLink: false,
      redirect: false,
      password1: '',
      password2: '',
      errors: {
        password1: [],
        password2: undefined,
        generalNetwork: undefined,
      },
      disabled: false,
    };

    this.handleValidatePassword = this.handleValidatePassword.bind(this);
  }

  checkPasswords = () => {
    // @ts-expect-error TS(2339): Property 'password1' does not exist on type 'Reado... Remove this comment to see the full error message
    const { password1, password2 } = this.state;

    if (password1 !== password2) {
      this.setState({
        errors: {
          password2: 'Passwords do not match',
        },
      });
    } else {
      this.setState({
        errors: {
          password2: undefined,
        },
      });
    }
  };

  handleSubmit = (event: any) => {
    event.preventDefault();
    // @ts-expect-error TS(2339): Property 'password1' does not exist on type 'Reado... Remove this comment to see the full error message
    const { password1, password2 } = this.state;

    // validate passwords before triggering request
    this.checkPasswords();
    if (password1 !== password2) {
      return;
    }

    // @ts-expect-error TS(2339): Property 'token' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { token } = this.props;
    const payload = {
      // @ts-expect-error TS(2339): Property 'firstName' does not exist on type 'Reado... Remove this comment to see the full error message
      firstName: this.state.firstName,
      // @ts-expect-error TS(2339): Property 'lastName' does not exist on type 'Readon... Remove this comment to see the full error message
      lastName: this.state.lastName,
      // @ts-expect-error TS(2339): Property 'password1' does not exist on type 'Reado... Remove this comment to see the full error message
      password: this.state.password1,
    };

    this.setState({
      disabled: true,
    });

    this.props
      // @ts-expect-error TS(2339): Property 'submitJoinExistingAccount' does not exis... Remove this comment to see the full error message
      .submitJoinExistingAccount(payload, token)
      .then(() => this.success())
      .catch((error: any) => this.error(error));
  };

  success = () => {
    // @ts-expect-error TS(2339): Property 'redirectUrl' does not exist on type 'Rea... Remove this comment to see the full error message
    const { redirectUrl } = this.props;

    if (_.isUndefined(redirectUrl)) {
      this.setState({ redirect: true, disabled: false, deepLink: false });
    } else {
      this.setState({ deepLink: true, redirect: false });
    }
  };

  error = (error: any) => {
    if (error.response.status === 400) {
      this.setState({
        errors: {
          password1: Object.values(error.response.data.errors),
        },
        disabled: false,
      });
    } else if (error.response.status === 404) {
      this.setState({
        errors: {
          generalNetwork: 'Email Setup Link Expired/Not Found!',
        },
        disabled: false,
      });
    } else if (error.response.status === 412) {
      const errorMessage =
        typeof error.response.data == 'string'
          ? error.response.data
          : 'Authorization Failed for Token';

      this.setState({
        errors: {
          generalNetwork: errorMessage,
        },
        disabled: false,
      });
    } else {
      this.setState({
        errors: {
          generalNetwork: 'Service Unavailable. Please try again.',
        },
        disabled: false,
      });
    }
  };

  handleChange = (name: any) => (event: any) => {
    this.setState({ [name]: event.target?.value }, this.checkPasswords);
  };

  handlePasswordOnChange = (field: any) => {
    return (value: any) => {
      this.setState(
        {
          [field]: value,
        },
        this.checkPasswords
      );
    };
  };

  handleError = (BEValidationErrors: any) => {
    this.setState((currState) => ({
      errors: {
        password1: BEValidationErrors,
        // @ts-expect-error TS(2339): Property 'errors' does not exist on type 'Readonly... Remove this comment to see the full error message
        password2: currState.errors.password2,
      },
    }));
  };

  render() {
    // @ts-expect-error TS(2339): Property 'redirect' does not exist on type 'Readon... Remove this comment to see the full error message
    const { redirect, tokenType, email, deepLink, disabled } = this.state;

    // @ts-expect-error TS(2339): Property 'redirectUrl' does not exist on type 'Rea... Remove this comment to see the full error message
    const { redirectUrl } = this.props;

    if (deepLink) {
      return <Redirect to={redirectUrl} />;
    }
    if (redirect) {
      return <Redirect to="/loading" />;
    }
    return (
      <div style={{ textAlign: 'left' }}>
        <form onSubmit={this.handleSubmit}>
          {_.eq(tokenType, 'QUOTE_SENT_NEW_USER') && (
            <Typography variant="body1" color="default" align="center">
              Please create a password for {email}
            </Typography>
          )}
          {_.eq(tokenType, 'QUOTE_LINK_NEW_AGENT') && (
            <Typography variant="body1" color="default" align="center">
              Please create a password for {email}
            </Typography>
          )}
          {!_.eq(tokenType, 'QUOTE_SENT_NEW_USER') &&
            !_.eq(tokenType, 'QUOTE_LINK_NEW_AGENT') && (
              <span>
                <Typography variant="body1" color="default" align="center">
                  Please enter below information to complete your{' '}
                  {/* @ts-expect-error TS(2339): Property 'data' does not exist on type 'Readonly<{... Remove this comment to see the full error message */}
                  {this.props.data.accountType === 'AGENCY'
                    ? 'agency'
                    : 'account'}{' '}
                  setup!
                </Typography>

                <TextField
                  id="firstName"
                  label="First Name"
                  required
                  // @ts-expect-error TS(2339): Property 'firstName' does not exist on type 'Reado... Remove this comment to see the full error message
                  value={this.state.firstName}
                  onChange={this.handleChange('firstName')}
                />

                <TextField
                  id="lastName"
                  label="Last Name"
                  required
                  // @ts-expect-error TS(2339): Property 'lastName' does not exist on type 'Readon... Remove this comment to see the full error message
                  value={this.state.lastName}
                  onChange={this.handleChange('lastName')}
                />
              </span>
            )}
          <CreatePasswordField
            // @ts-expect-error TS(2322): Type '{ id: string; label: string; required: true;... Remove this comment to see the full error message
            id="password1"
            label="Password"
            required
            // @ts-expect-error TS(2339): Property 'errors' does not exist on type 'Readonly... Remove this comment to see the full error message
            errors={this.state.errors.password1}
            onChange={this.handlePasswordOnChange('password1')}
            onError={({ errors }: any) => this.handleError(errors)}
            onValidate={this.handleValidatePassword}
          />
          <div style={{ paddingTop: '.8rem' }}>
            <PasswordField
              // @ts-expect-error TS(2322): Type '{ id: string; name: string; label: string; v... Remove this comment to see the full error message
              id="password2"
              name="password2"
              label="Confirm Password"
              // @ts-expect-error TS(2339): Property 'password2' does not exist on type 'Reado... Remove this comment to see the full error message
              value={this.state.password2}
              required
              onChange={this.handleChange('password2')}
              // @ts-expect-error TS(2339): Property 'errors' does not exist on type 'Readonly... Remove this comment to see the full error message
              error={this.state.errors.password2}
            />
            {/* @ts-expect-error TS(2339): Property 'errors' does not exist on type 'Readonly... Remove this comment to see the full error message */}
            <span className="error-text">{this.state.errors.password2}</span>
          </div>
          {/* @ts-expect-error TS(2339): Property 'errors' does not exist on type 'Readonly... Remove this comment to see the full error message */}
          <span className="error-text">{this.state.errors.generalNetwork}</span>
          <div style={{ textAlign: 'center', marginTop: '15px' }}>
            <CBButton
              loading={disabled}
              // @ts-expect-error TS(2339): Property 'disabled' does not exist on type 'Readon... Remove this comment to see the full error message
              disabled={this.state.disabled}
              type="submit"
              styleName="ctaButton"
              buttonText="Create account"
              size="large"
            />
          </div>
        </form>
        {/* @ts-expect-error TS(2769): No overload matches this call. */}
        <Typography type="body1" align="center" style={{ marginTop: 15 }}>
          Have an account? <Link to="/login">Sign in</Link>
        </Typography>
        {/* @ts-expect-error TS(2339): Property 'errors' does not exist on type 'Readonly... Remove this comment to see the full error message */}
        {this.state.errors.generalNetwork && (
          // @ts-expect-error TS(2769): No overload matches this call.
          <Typography
            type="body1"
            align="center"
            style={{ paddingTop: '10px', color: 'red' }}
          >
            {/* @ts-expect-error TS(2339): Property 'errors' does not exist on type 'Readonly... Remove this comment to see the full error message */}
            {this.state.errors.generalNetwork}
          </Typography>
        )}
      </div>
    );
  }

  handleValidatePassword(password: any) {
    // @ts-expect-error TS(2339): Property 'match' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { match } = this.props;

    return validatePassword({ token: match.params.token }, { password });
  }
}

// @ts-expect-error TS(2345): Argument of type 'typeof SignupEmailExisting' is not assignable to parameter of type...
export default withRouter(SignupEmailExisting);
